export default {
      id: "asset-utilization-report-usage",
      viewBox: "0 0 47 42",
      url: __webpack_public_path__ + "img/icons.svg#asset-utilization-report",
      toString: function () {
        return this.url;
      }
    }